import React, { FC, useEffect, useState } from 'react';
import * as styles from './ArticleHeader.module.scss';
import { useColor } from '../../hooks/useColor';
import { usePageContext } from '../../context/pageContext';

interface Props {
  category: string;
  textColor?: string;
  type: string;
  topBorder: boolean;
}

const ArticleHeader: FC<Props> = ({ category, textColor, type, topBorder }) => {
  const { lang } = usePageContext();
  const [experienceType, setExperienceType] = useState();

  const experienceTypeTranslations = {
    testimonial: {
      fr: 'Témoignage',
      es: 'Testimonio',
      de: 'Zeugnis',
      it: 'Testimonianza',
      en: 'Testimonial',
    },
    article: {
      fr: 'Article',
      es: 'Artículo',
      de: 'Artikel',
      it: 'Articolo',
      en: 'Article',
    },
    video: {
      fr: 'Vidéo',
      es: 'Vídeo',
      de: 'Video',
      it: 'Video',
      en: 'Video',
    },
    study: {
      fr: 'Étude',
      es: 'Estudio',
      de: 'Studie',
      it: 'Studio',
      en: 'Study',
    },
  };

  useEffect(() => {
    setExperienceType(experienceTypeTranslations[type][lang]);
  }, [lang, type]);

  return (
    <div
      className={styles.wrapper}
      style={{ borderTop: topBorder ? '1px solid #bfbfbf' : '0' }}
    >
      <span style={{ color: useColor(textColor) }}>{category}</span>
      <span style={{ color: '#00000040' }}>{experienceType}</span>
    </div>
  );
};
export default ArticleHeader;
